export { default } from "./PowerWordButton";
